export var getWillLocationDropdownOpenAbove = function getWillLocationDropdownOpenAbove(element, defaultValue) {
  if (!element || !element.getBoundingClientRect) return defaultValue;
  return element.getBoundingClientRect().top > 450;
};